import {useCallback, useEffect, useState} from 'react'
import {serverPhoneFormat} from 'services/utils/apiUtils'
import {useForgotPasswordMutation} from 'store/Store'

const useForgotPassword = () => {
    const [forgotPasswordResponse, setForgotPasswordResponse] = useState()
    const [forgotPasswordError, setForgotPasswordError] = useState()

    const [
        doForgotPassword, // This is the mutation trigger
        {isLoading, error, data}, // This is the destructured mutation result
    ] = useForgotPasswordMutation()

    const clearForgotPasswordError = () => setForgotPasswordError(null)

    useEffect(() => {
        setForgotPasswordResponse(data)
        // if (data?.success) {
        //     setForgotPasswordResponse(data)
        // } else {
        //     setForgotPasswordError(data)
        // }
    }, [data])

    useEffect(() => {
        if (error) {
            if (error?.data) {
                setForgotPasswordError(error?.data)
            } else {
                setForgotPasswordError(error)
            }
        }
    }, [error])

    const forgotPassword = useCallback(
        (loginData) => {
            const {username, password} = loginData
            doForgotPassword({
                phone: serverPhoneFormat(username),
                password,
            })
        },
        [doForgotPassword]
    )

    return {
        isLoading,
        doForgotPassword: forgotPassword,
        forgotPasswordResponse,
        forgotPasswordError,
        clearForgotPasswordError,
    }
}

export default useForgotPassword
